import 'angular';
import 'angular-ui-bootstrap';
import '../../../../lib/assets/javascripts/devex/alerts';
import template from './share.template.html?raw';
import shareByEmailTemplate from './share_by_email.modal.html?raw';
import shareByLinkTemplate from './share_link.modal.html?raw';
import { copyToClipboardFromInputId } from '../../utilities/utilities';

angular
  .module('components.share', [
    'ui.bootstrap.dropdown',
    'ui.bootstrap.tpls',
    'ui.bootstrap.modal',
  ])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
    $templateCache.put(shareByEmailTemplate, shareByEmailTemplate);
    $templateCache.put(shareByLinkTemplate, shareByLinkTemplate);
  }])
  .component('share', {
    templateUrl: template,
    bindings: {
      itemId: '<',
      itemType: '<',
      modalText: '<',
      isExpandedView: '<',
    },
    controller: [
      '$rootScope',
      '$http',
      '$uibModal',
      '$scope',
      function ShareController($rootScope, $http, $uibModal, $scope) {
        var that = this;

        /**
         * When bindings are all present, set controller variables and generate modal scope
         *
         * @returns {undefined}
         */
        that.initComponentController = () => {
          that.myModal = null;
          that.$http = $http;
          that.generateModalScope();
        };

        /**
         * Generate a new scope for the different modals that are used in this page. The modals will
         * then not rely on this controller's scope and worry about what they have to do.
         *
         * @returns {undefined}
         */
        that.generateModalScope = () => {
          that.modalScope = $rootScope.$new();
          that.modalScope.hasCopiedLink = false;
          that.modalScope.modalText = that.modalText;
          that.modalScope.itemType = that.itemType;
          that.modalScope.inputModels = {
            emails: '',
            message: '',
          };
          that.modalScope.loading = false;
          that.modalScope.shareableLink = null;

          /**
           * In Get shareable link modal, selects the input containing the share link and copies
           * the link to the clipboard
           *
           * @returns {undefined}
           */
          that.modalScope.copyTextToClipboard = async () => {
            const result = await copyToClipboardFromInputId('shareableLink');
            that.modalScope.hasCopiedLink = result;
            $scope.$apply();
          };

          /**
           * In Share by email modal, makes a POST request to the BE with the Emails, Message and
           * Item for sharing by emails.
           *
           * @returns {undefined}
           */
          that.modalScope.sendEmail = () => {
            that.modalScope.loading = true;
            that.$http
              .post('/api/sharing_tokens', {
                item_id: that.itemId,
                item_type: that.itemType,
                share_via_email: {
                  email_addresses: that.createArrayOfEmails(that.modalScope.inputModels.emails),
                  message: that.modalScope.inputModels.message,
                },
              })
              .then(() => {
                devex.alerts.showAlert(
                  `You have successfully emailed this ${that.itemType}`,
                  'success'
                );
              })
              .catch(() => {
                devex.alerts.showAlert(`Error sharing ${that.itemType} via email`, 'error');
              })
              .finally(() => {
                that.modalScope.loading = false;
                that.myModal.close();
                that.modalScope.inputModels = {
                  emails: '',
                  message: '',
                };
              });
          };
        };

        /**
         * Makes a POST request to the back-end for the sharing token, then opens
         * a modal to the user with the shareable link.
         *
         * @returns {undefined}
         */
        that.getSharingToken = () => {
          that.modalScope.hasCopiedLink = false;
          that.$http
            .post('/api/sharing_tokens', {
              item_id: that.itemId,
              item_type: that.itemType,
            })
            .then((response) => {
              that.modalScope.shareableLink = `${window.location.origin}/shared/${response.data.token}`;
              $uibModal.open({
                templateUrl: shareByLinkTemplate,
                scope: that.modalScope,
                animation: false,
                windowTopClass: 'share-link-modal-container',
              });
            })
            .catch(() => {
              devex.alerts.showAlert('Error generating shareable link', 'error');
            });
        };

        /**
         * Opens Share by email modal with the Email and Message fields to share item by email.
         *
         * @returns {undefined}
         */
        that.shareByEmail = () => {
          that.myModal = $uibModal.open({
            templateUrl: shareByEmailTemplate,
            scope: that.modalScope,
            animation: false,
            windowTopClass: 'share-email-modal-container',
          });
        };

        /**
         * Returns an array with all the emails or an array with just one email
         * removing spaces and makes sure the email has an at.
         *
         * @param {string} emails or email. Note that emails should be separated by a space
         * @returns {Array} array of emails or email
         */
        that.createArrayOfEmails = (emails) => {
          return emails.split(' ').filter((email) => email.indexOf('@') !== -1);
        };

        that.$onInit = that.initComponentController;
      },
    ],
    controllerAs: 'vm',
  });
